// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Implantacao_AnexoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /implantacao/anexo — a franqueadora anexa o arquivo de um item (o contrato assinado,
 * por exemplo). multipart: o arquivo vem em `arquivo`. O controller confere o TIPO lendo os
 * bytes (PDF ou imagem), nunca pelo que o navegador declara. Chamado NS 2026-0079.
 */
import { registerContract } from './validate'

export interface Implantacao_AnexoInput {
_files: unknown[]
franquia_id?: number
item_chave?: string
}

registerContract('Implantacao_AnexoInput', {
  _files:      { type: 'array',   required: true },
  franquia_id: { type: 'number',  required: false },
  item_chave:  { type: 'string',  required: false },
})
